import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Layout, Typography, Modal } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

const { Content } = Layout;

const Confirm = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  useEffect(() => {
    const confirmRegistration = async () => {
      const token = searchParams.get('token');
      if (!token) {
        setModalMessage('Invalid confirmation link.');
        setIsModalVisible(true);
        return;
      }

      try {
        const response = await fetch(`/backend/register.php?token=${token}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || 'Confirmation failed');
        }

        setModalMessage('Inscription confirmée avec succès ! Vous serez redirigé vers la page de connexion dans <strong>5 secondes</strong>.');
        setIsModalVisible(true);

        setTimeout(() => {
          setIsModalVisible(false);
          navigate('/login');
        }, 5000);
      } catch (error) {
        setModalMessage(error.message || 'Échec de la confirmation. Veuillez réessayer.');
        setIsModalVisible(true);
      }
    };

    confirmRegistration();
  }, [searchParams, navigate]);

  return (
    <Layout style={{ minHeight: '100vh', background: 'linear-gradient(135deg,rgb(249, 250, 252), #f9fafb)' }}>
      <Content style={{ padding: '50px 20px', textAlign: 'center' }}>
        <Typography.Title level={3}>Confirmation en cours...</Typography.Title>
      </Content>

      <Modal
        title={
          <div
            style={{
              background: '#10b981',
              color: '#fff',
              padding: '15px 25px',
              borderRadius: '12px 12px 0 0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '18px',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '1px',
              transition: 'all 0.3s ease',
            }}
          >
            <CheckCircleOutlined style={{ marginRight: '15px', fontSize: '22px', animation: 'pulse 1.5s infinite' }} />
            Confirmation Réussie
          </div>
        }
        open={isModalVisible}
        footer={null}
        closable={false}
        style={{
          top: '20%',
          borderRadius: '15px',
          boxShadow: '0 15px 30px rgba(0, 0, 0, 0.15)',
          overflow: 'hidden',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        }}
        bodyStyle={{
          padding: '30px',
          textAlign: 'center',
          fontSize: '16px',
          color: '#1e293b',
          lineHeight: '1.7',
          fontFamily: '"Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
          background: 'linear-gradient(135deg, #f0fff4, #ffffff)',
        }}
      >
        <div style={{ marginBottom: '20px', fontSize: '28px', color: '#10b981', animation: 'bounce 0.5s' }}>
          <CheckCircleOutlined style={{ fontSize: '50px', marginBottom: '10px' }} />
        </div>
        <p style={{ marginBottom: '15px', fontWeight: 400 }} dangerouslySetInnerHTML={{ __html: modalMessage }}></p>
        <div style={{ marginTop: '20px', color: '#64748b', fontStyle: 'italic', fontSize: '14px' }}>
          Redirection dans <span style={{ color: '#10b981', fontWeight: 'bold', animation: 'blink 1s infinite' }}>5</span> secondes...
        </div>
      </Modal>

      <style>
        {`
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.1); }
            100% { transform: scale(1); }
          }
          @keyframes bounce {
            0% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
            100% { transform: translateY(0); }
          }
          @keyframes blink {
            50% { opacity: 0; }
          }
        `}
      </style>
    </Layout>
  );
};

export default Confirm;